/* CDT Studio — CDT inference measurements. Browser build: globalThis.CDTInfer.
   Generated mechanically from algo v3 infer.js + plan.js (cdt-auto-resolve_3.zip):
   the measurement functions and the size-key helpers below are VERBATIM slices of
   those files — only the fs/CLI shell was replaced by the infer(canvas, itemsDoc,
   deps) wrapper. Verified to produce JSON identical to 'node algo/infer.js --json' on the baked reference plan (2026-08-20). Do not edit; regenerate from the algo
   sources instead. deps = { loadPlan, Plan, grade } from globalThis.CDTResolve. */
(function (root) {
  'use strict';
  const SEP = ' › ';
const UNIT_FAMILY = [
  [/fl\s*oz/i, 'volume', 1],
  [/\bml\b/i, 'volume', 0.033814],
  [/\bl\b/i, 'volume', 33.814],
  [/\blb\b|pound/i, 'mass', 16],
  [/\boz\b/i, 'mass', 1],
  [/\bg\b/i, 'mass', 0.035274],
  [/\bct\b|count|\bpk\b|pack/i, 'count', 1],
  [/load/i, 'loads', 1],
];
const FAMILY_ORDER = ['count', 'loads', 'mass', 'volume', 'other'];
function parseSize(label) {
  if (label == null) return { family: 'other', mag: 0, raw: '' };
  const s = String(label);
  const m = s.match(/-?\d+(?:\.\d+)?/);
  const n = m ? parseFloat(m[0]) : 0;
  for (const [re, family, mult] of UNIT_FAMILY) {
    if (re.test(s)) return { family, mag: n * mult, raw: s };
  }
  return { family: 'other', mag: n, raw: s };
}
function sizeKey(label) {
  const p = parseSize(label);
  const f = FAMILY_ORDER.indexOf(p.family);
  return [(f < 0 ? FAMILY_ORDER.length : f), p.mag];
}
  function infer(canvas, itemsDoc, deps) {
    const loadPlan = deps.loadPlan, Plan = deps.Plan, G = deps.grade;
    const plan = loadPlan(canvas, itemsDoc);
    const SPINE = plan.spine;
    const LABEL = itemsDoc.LABELS || {};
    const lab = (a) => LABEL[a] || a;
const pct = (n, d) => (d ? (100 * n / d).toFixed(0) + '%' : '—');
const report = { levels: [], gradient: {}, sizes: {}, order: [], notes: [] };

/* ── the blocks a level splits inside ──────────────────────────────────────
   For level d, group the plan by the path above it. Each group is one parent
   block, and within it the level's values are the children being arranged. */
function parents(depth) {
  const out = new Map();
  plan.all().forEach((it) => {
    const k = it.path.slice(0, depth).join(SEP);
    if (!out.has(k)) out.set(k, []);
    out.get(k).push(it);
  });
  return out;
}

function span(items) {
  return {
    x0: Math.min(...items.map((i) => i.x)),
    x1: Math.max(...items.map((i) => Plan.right(i))),
    shelves: new Set(items.map((i) => i.run + '|' + i.shelf)),
    meanX: items.reduce((s, i) => s + i.x + Plan.width(i) / 2, 0) / items.length,
    meanShelf: items.reduce((s, i) => s + i.shelf, 0) / items.length,
  };
}

/* ── 2 · how does each level actually split? ───────────────────────────────
   Take every pair of sibling values inside every parent block and ask whether
   they are separated along the shelf (their x-ranges do not overlap) or down the
   shelves (they share no shelf). Whichever wins is how the plan builds that
   level, whatever ORIENT claims. */
function orientationEvidence() {
  SPINE.forEach((attr, d) => {
    let xSep = 0, ySep = 0, both = 0, neither = 0, pairs = 0, blocks = 0;
    const exceptions = [];
    parents(d).forEach((items, key) => {
      const byVal = new Map();
      items.forEach((it) => {
        const v = String(it.path[d]);
        if (!byVal.has(v)) byVal.set(v, []);
        byVal.get(v).push(it);
      });
      if (byVal.size < 2) return;
      blocks++;
      const vals = [...byVal.entries()].map(([v, its]) => ({ v, its, s: span(its) }));
      let localX = 0, localY = 0, localPairs = 0;
      for (let i = 0; i < vals.length; i++) {
        for (let j = i + 1; j < vals.length; j++) {
          const a = vals[i].s, b = vals[j].s;
          const xd = a.x1 <= b.x0 + 0.5 || b.x1 <= a.x0 + 0.5;
          const yd = ![...a.shelves].some((z) => b.shelves.has(z));
          pairs++; localPairs++;
          if (xd && yd) { both++; localX++; localY++; }
          else if (xd) { xSep++; localX++; }
          else if (yd) { yWin(); localY++; }
          else neither++;
          function yWin() { ySep++; }
        }
      }
      // a block that reads the opposite way from the level as a whole
      if (localPairs >= 3) exceptions.push({ key, x: localX, y: localY, pairs: localPairs });
    });
    const declared = plan.orient[attr] || 'horizontal';
    const measured = xSep + both / 2 >= ySep + both / 2
      ? (xSep >= ySep ? 'horizontal' : 'vertical')
      : 'vertical';
    const lvl = {
      depth: d, attr, label: lab(attr), declared, measured,
      pairs, blocks, xOnly: xSep, yOnly: ySep, both, neither,
      agrees: declared === measured,
      contrary: exceptions.filter((e) => (declared === 'horizontal' ? e.y > e.x : e.x > e.y)),
    };
    report.levels.push(lvl);
  });
}

/* ── 3 · does each level's value order match the shelf? ────────────────────
   For a horizontal level, sort each parent block's values by mean x and compare
   with vorder; for a vertical level, sort by shelf, top first. Count concordant
   and discordant pairs — a Kendall-style agreement. Size is measured against the
   magnitude rule instead of the stored list, because that is what the algorithm
   uses and what the size defects ask for. */
function orderEvidence() {
  SPINE.forEach((attr, d) => {
    const isSize = attr === '__sizeLabel';
    const vertical = (plan.orient[attr] || 'horizontal') === 'vertical';
    let conc = 0, disc = 0;
    const worst = new Map();
    parents(d).forEach((items, key) => {
      const byVal = new Map();
      items.forEach((it) => {
        const v = String(it.path[d]);
        if (!byVal.has(v)) byVal.set(v, []);
        byVal.get(v).push(it);
      });
      if (byVal.size < 2) return;
      const vals = [...byVal.entries()].map(([v, its]) => ({ v, s: span(its) }));
      const rank = (v) => {
        if (!isSize) return plan.rank(attr, v);
        const k = sizeKey(v);
        return k[0] * 1e9 + k[1];
      };
      for (let i = 0; i < vals.length; i++) {
        for (let j = i + 1; j < vals.length; j++) {
          const a = vals[i], b = vals[j];
          const dr = rank(a.v) - rank(b.v);
          if (dr === 0) continue;
          const dp = vertical ? (a.s.meanShelf - b.s.meanShelf) : (a.s.meanX - b.s.meanX);
          if (Math.abs(dp) < 0.01) continue;
          if ((dr < 0) === (dp < 0)) conc++;
          else {
            disc++;
            const kk = [a.v, b.v].join('  ·before·  ');
            worst.set(kk, (worst.get(kk) || 0) + 1);
          }
        }
      }
    });
    report.order.push({
      attr, label: lab(attr), vertical, isSize, conc, disc,
      agreement: conc + disc ? conc / (conc + disc) : null,
      worst: [...worst.entries()].sort((a, b) => b[1] - a[1]).slice(0, 4)
        .map(([k, n]) => ({ pair: k, n })),
    });
  });
}

/* ── 3b · is there an inferable order at all? ──────────────────────────────
   Three candidates compete to explain the as-built sequence: the stored vorder
   list, the order the defects' own seqOrder blobs imply, and (for size) the
   magnitude rule. Scoring all three on the same sibling pairs answers a question
   worth answering before trusting any of them — whether the plan sequences that
   level consistently at all. A level where every candidate lands near 50% is not
   a level the plan can be said to have an order for. */
function candidateEvidence() {
  const chains = {};
  (canvas.pins || []).filter((p) => p.seqOrder && p.seqOrder.length > 1).forEach((pin) => {
    const d = pin.scope.split(SEP).filter((z) => z !== '*').length;
    const attr = SPINE[Math.min(d, SPINE.length - 1)];
    const seen = [];
    pin.seqOrder.forEach((id) => {
      const it = plan.get(id);
      if (!it) return;
      const v = String(it.path[d]);
      if (seen.indexOf(v) < 0) seen.push(v);
    });
    if (!chains[attr]) chains[attr] = [];
    seen.forEach((v) => { if (chains[attr].indexOf(v) < 0) chains[attr].push(v); });
  });

  const score = (attr, d, rankFn) => {
    const vertical = (plan.orient[attr] || 'horizontal') === 'vertical';
    let c = 0, x = 0;
    parents(d).forEach((items) => {
      const byVal = new Map();
      items.forEach((it) => {
        const v = String(it.path[d]);
        if (!byVal.has(v)) byVal.set(v, []);
        byVal.get(v).push(it);
      });
      if (byVal.size < 2) return;
      const vals = [...byVal.entries()].map(([v, its]) => ({ v, s: span(its) }));
      for (let i = 0; i < vals.length; i++) {
        for (let j = i + 1; j < vals.length; j++) {
          const a = vals[i], b = vals[j];
          const dr = rankFn(a.v) - rankFn(b.v);
          if (!dr) continue;
          const dp = vertical ? (a.s.meanShelf - b.s.meanShelf) : (a.s.meanX - b.s.meanX);
          if (Math.abs(dp) < 0.01) continue;
          if ((dr < 0) === (dp < 0)) c++; else x++;
        }
      }
    });
    return c + x ? c / (c + x) : null;
  };

  report.candidates = SPINE.map((attr, d) => {
    const ch = chains[attr];
    return {
      attr, label: lab(attr),
      vorder: score(attr, d, (v) => plan.rank(attr, v)),
      pins: ch ? score(attr, d, (v) => (ch.indexOf(v) < 0 ? 1e6 : ch.indexOf(v))) : null,
      magnitude: attr === '__sizeLabel'
        ? score(attr, d, (v) => { const k = sizeKey(v); return k[0] * 1e9 + k[1]; }) : null,
    };
  });
}

/* ── 4 · the vertical gradient, per section ────────────────────────────────
   Is the median pack bigger further down? Measured per subcategory as well as
   per aisle, because a section that runs the other way is exactly the kind of
   exception that has to be seen rather than averaged away. */
function gradientEvidence() {
  const med = (v) => (v.length ? v.slice().sort((a, b) => a - b)[Math.floor(v.length / 2)] : 0);
  const byRun = [];
  canvas.geo.forEach((geo, run) => {
    const rows = geo.shelves.map((s) => s.rank).sort((a, b) => a - b).map((sh) => {
      const l = plan.all().filter((i) => i.run === run && i.shelf === sh);
      return { shelf: sh, n: l.length, h: +med(l.map((i) => i.h)).toFixed(1),
        pitch: +geo.shelves.find((z) => z.rank === sh).pitch.toFixed(1) };
    });
    let ok = 0, bad = 0;
    for (let i = 1; i < rows.length; i++) (rows[i].h >= rows[i - 1].h ? ok++ : bad++);
    byRun.push({ run, rows, monotoneSteps: ok, counterSteps: bad });
  });
  const sections = [];
  const secs = [...new Set(plan.all().map((i) => i.path[0]))];
  secs.forEach((sec) => {
    const l = plan.all().filter((i) => i.path[0] === sec);
    const shelves = [...new Set(l.map((i) => i.shelf))].sort((a, b) => a - b);
    if (shelves.length < 2) return;
    const rows = shelves.map((sh) => ({ shelf: sh, h: +med(l.filter((i) => i.shelf === sh).map((i) => i.h)).toFixed(1) }));
    let ok = 0, bad = 0;
    for (let i = 1; i < rows.length; i++) (rows[i].h >= rows[i - 1].h ? ok++ : bad++);
    sections.push({ sec, rows, ok, bad });
  });
  report.gradient = { byRun, sections, inversions: G.totalInversions(plan) };
}

/* ── the size label itself ─────────────────────────────────────────────────
   The magnitude rule only works if the labels parse and if a block does not mix
   unit families. Both fail somewhere in this data, and the algorithm's fallback
   for each is a judgement call. */
function sizeEvidence() {
  const d = SPINE.indexOf('__sizeLabel');
  const all = plan.all();
  const unparsed = all.filter((i) => sizeKey(i.path[d])[1] === 0);
  const mixed = [];
  G.blocksAt(plan).forEach((ids, node) => {
    const fams = new Set(ids.map((id) => sizeKey(plan.get(id).path[d])[0]));
    if (fams.size > 1) {
      const detail = {};
      ids.forEach((id) => {
        const k = sizeKey(plan.get(id).path[d]);
        const f = ['count', 'loads', 'mass', 'volume', 'other'][k[0]] || 'other';
        detail[f] = (detail[f] || 0) + 1;
      });
      mixed.push({ node, families: detail, n: ids.length });
    }
  });
  const listed = (itemsDoc.ORDER.__sizeLabel || []).slice(0, 8);   // raw, before loadPlan sorts it
  report.sizes = {
    total: all.length,
    unparsed: unparsed.map((i) => ({ id: i.id, label: String(i.path[d]), h: i.h, w: i.w })),
    mixedBlocks: mixed.sort((a, b) => b.n - a.n),
    storedListHead: listed,
  };
}

/* ── what the pins claim, against what the tree says ───────────────────── */
function pinEvidence() {
  const out = [];
  (canvas.pins || []).filter((p) => p.seqOrder && p.seqOrder.length > 1).forEach((pin) => {
    const depth = pin.scope.split(SEP).filter((s) => s !== '*').length;
    const attr = SPINE[Math.min(depth, SPINE.length - 1)];
    const seen = [];
    pin.seqOrder.forEach((id) => {
      const it = plan.get(id);
      if (!it) return;
      const v = String(it.path[depth]);
      if (seen.indexOf(v) < 0) seen.push(v);
    });
    let back = 0;
    for (let i = 1; i < seen.length; i++) {
      if (attr === '__sizeLabel') {
        const a = sizeKey(seen[i - 1]), b = sizeKey(seen[i]);
        if (a[0] === b[0] && b[1] < a[1]) back++;
      } else if (plan.rank(attr, seen[i - 1]) > plan.rank(attr, seen[i])) back++;
    }
    if (back) out.push({ scope: pin.scope, attr, label: lab(attr), back, seen });
  });
  report.pins = out;
}

orientationEvidence();
orderEvidence();
candidateEvidence();
gradientEvidence();
sizeEvidence();
pinEvidence();
    return report;
  }
  root.CDTInfer = { infer };
})(typeof window !== 'undefined' ? window : globalThis);
